export default __webpack_public_path__ + "static/media/2212.4a48aa7a.png";